import * as React from 'react';
import { ChecklistUIStyle } from './style';
import { useDispatch } from "react-redux";
import { changeCheklistStatus } from './shiftDetailsSlice';
import Constants from '../../utils/constants';
import { useState } from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '../../utils/ui';


const CheckListItem = ({ checkListId, items }) => {
    const dispatch = useDispatch();
    const chekListItemsStyle = {
        paddingLeft: 20
    }

    const item = (chklItems, chekListItemsStyle, leftPadding) => {
        if (leftPadding) {
            chekListItemsStyle.paddingLeft += leftPadding;
        }

        const handleChange = (itemID) => (event) => {
            dispatch(changeCheklistStatus({ checklistId: checkListId, itemId: itemID, bodyData: { resolved: event.target.checked } }));
        };

        return (
            <div>
                {chklItems.map((checkItem, index) =>{
                    return (
                        <div key={index}>
                            <FormControlLabel onTouchStart={(e) => {
                                e.target.style.color = Constants.COLORS.ORANGE
                            }}
                                onTouchEnd={(e) => {
                                    e.target.style.color = '';
                                }}
                                //Add <p></p> tag in Label
                                style={{ ...chekListItemsStyle }} control={<Checkbox onChange={handleChange(checkItem.id)} checked={checkItem.resolved} />} label={<div dangerouslySetInnerHTML={{ __html: checkItem.name }} />} />
                            {(checkItem.children && checkItem.children.length) ? item(checkItem.children, { ...chekListItemsStyle }, 20) : ''}
                        </div>
                    );
                })}
            </div>
        );
    }
    return (
        <div className='chklistitemsContainer'>
            <FormGroup>
                {item(items, chekListItemsStyle)}
            </FormGroup>
        </div>
    );

}

export default function CheckList({ checklistArray }) {
    const { ASSETS } = Constants;
    const [isCheckListItemExpanded, setCheckListItemExpanded] = useState(false);
    const [expandedChecklistIndex, setExpandedChecklistIndex] = useState(0);

    const toggleChecklist = (index) => (e) => {
        e.preventDefault();
        setExpandedChecklistIndex(index);
        if (expandedChecklistIndex === index || expandedChecklistIndex + 1 === index || expandedChecklistIndex - 1 === index) {
            let isExpanded = isCheckListItemExpanded;
            setCheckListItemExpanded(!isExpanded);
        }
    };

    return (
        <ChecklistUIStyle>
            {checklistArray.map((checklist, index) => {
                return (
                    <div key={index}>
                        <div className='checklist' onClick={toggleChecklist(index)}>
                            <div className='name'>{checklist.name}</div>
                            <div className='cheklistRightSection'>
                                {!checklist.unresolved ?
                                    <img src={ASSETS.CHECK_MARK_COMPLETE.PATH} alt={ASSETS.CHECK_MARK_COMPLETE.ALT_TEXT} />
                                    : <img src={ASSETS.CHECK_MARK_PENDING.PATH} alt={ASSETS.CHECK_MARK_PENDING.ALT_TEXT} />}
                                {(expandedChecklistIndex === index && isCheckListItemExpanded) ?
                                    <img className='expand' src={ASSETS.ARROW_COLLASP.PATH} alt={ASSETS.ARROW_COLLASP.ALT_TEXT} />
                                    : <img className='expand' src={ASSETS.ARROW_EXPANDED.PATH} alt={ASSETS.ARROW_EXPANDED.ALT_TEXT} />
                                }
                            </div>
                        </div>
                        {(expandedChecklistIndex === index && isCheckListItemExpanded) && <CheckListItem checkListId={checklist.id} items={checklist.items} />}
                    </div>
                );
            })}
        </ChecklistUIStyle >
    )
}